import React from 'react';
import PropTypes from 'prop-types';
import { FolderInput } from 'lucide-react';
import { Flex } from 'rebass/styled-components';

import { Card } from 'components/atoms/Card';
import ActionsIcon from 'pages/contactsExtended/bulkActions/actionsIcon';
import ActionsSearch from 'pages/contactsExtended/bulkActions/actionsSearch';
import { useBulkMoveToFolder } from '../hooks/useBulkMoveToFolder';

export const ActionMoveToFolder = ({ selectedRows, networkId, onMoved }) => {
  const { containerRef, showCard, toggle, close, search, setSearch, options, isFetching, isLoading, title, onSelect } =
    useBulkMoveToFolder({ selectedRows, networkId, onMoved });

  return (
    <Flex
      ref={containerRef}
      sx={{
        flex: 'none',
        position: ['initial', 'initial', 'relative'],
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      {showCard && (
        <Card
          width="320px"
          height="352px"
          mb="0"
          p="16px"
          bg="neutral.0"
          sx={{
            position: 'absolute',
            bottom: ['50px', '50px', '40px'],
            left: ['20px', '20px', '0'],
          }}
        >
          <ActionsSearch
            title={title}
            value={search}
            options={options}
            isLoading={isFetching}
            isCreating={isLoading}
            onSearch={setSearch}
            onSelect={onSelect}
            newItemText=""
          />
        </Card>
      )}
      <ActionsIcon icon={FolderInput} text="Move to folder" onClick={() => (showCard ? close() : toggle())} />
    </Flex>
  );
};

ActionMoveToFolder.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  networkId: PropTypes.number.isRequired,
  onMoved: PropTypes.func,
};

ActionMoveToFolder.defaultProps = {
  onMoved: undefined,
};

export default ActionMoveToFolder;
